<template>
  <div class="localization">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <!-- {{profileArr}} -->
                  <div class="col-sm-12">
                    <h3 class="page-title">Localization</h3>
                  </div>
                </div>
              </div>
              <!-- /Page Header -->
              <!-- {{memberSession}} -->
              <form @submit.prevent="updateTimezone" class="was-validated">
                <div class="row">
                  <div class="col-sm-3"></div>
                  <!-- {{formTimezone.timezone}} -->
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Timezone</label>
                      <select v-model="formTimezone.timezone" class="form-control" required>
                        <option
                          v-for="(row,index) in timezoneList"
                          :key="index"
                          :value="row.timezone"
                        >{{row.name}}</option>
                      </select>
                      Tz: {{formTimezone.timezone}}
                    </div>
                  </div>
                  <div class="col-sm-3"></div>

                  <div class="col-sm-12">
                    <div class="submit-section">
                      <button :disabled="isLoading" class="btn btn-primary submit-btn">Save</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion
  },
  computed: {
    memberSession() {
      return this.$store.state.login.memberSession;
    }
  },
  data() {
    return {
      isLoading: false,
      timezoneList: [],
      formTimezone: {
        timezone: ""
      },
      profileArr: {}
    };
  },
  async created() {
    await this.getProfile();
    // this.formTimezone.timezone = await this.memberSession.timezone;

    await this.getTimezones();
  },
  methods: {
    changeSelect(value) {
      console.log("value", value);
      this.formTimezone.timezone = value;
    },
    updateTimezone() {
      this.isLoading = true;
      console.log("this.formTimezone", this.formTimezone);
      this.$store
        .dispatch("member/updateTimezone", this.formTimezone)
        .then(response => {
          this.isLoading = false;

          this.$fire({
            title: "Success",
            text: response["msg"],
            type: "success",
            timer: 2000
          });
          this.getProfile();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getTimezones() {
      this.$store.dispatch("member/getTimezones").then(response => {
        let { data } = response;
        this.timezoneList = data;
      });
    },
    getProfile() {
      this.$store.dispatch("login/getProfile").then(response => {
        let { data } = response;
        this.profileArr = data;
        this.formTimezone.timezone = this.profileArr.timezone;
      });
    }
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "localization"
};
</script>


// WEBPACK FOOTER //
// src/components/localization.vue